import { router, Stack } from 'expo-router';
import { useIsFocused } from 'expo-router/react-navigation';
import { buildSignUpUrlParams } from 'features/v2a/receiver/helpers/V2A.helpers';
import { V2AReceiverContext } from 'features/v2a/receiver/providers/V2AReceiverContextProvider';
import React, { useContext } from 'react';
import { IdleTimeoutProvider } from 'shared/providers/IdleTimeoutContext';

export default function V2AReceiverLayout() {
  const isFocused = useIsFocused();
  const { paymentDetails } = useContext(V2AReceiverContext);

  const handleTimeout = () => {
    if (isFocused && paymentDetails) {
      const signUpPageUrlParams = buildSignUpUrlParams(paymentDetails);
      router.push({ pathname: '/signup', params: signUpPageUrlParams });
    }
  };

  return (
    <IdleTimeoutProvider timeoutDurationInMin={5} onTimeout={handleTimeout}>
      <Stack screenOptions={{ headerShown: false }} />
    </IdleTimeoutProvider>
  );
}
